import React from "react";

var PencilIcon = function PencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.526 15.046L0 24l8.954-2.526 10.035-10.035-6.428-6.428zM22.668 1.332A4.512 4.512 0 0 0 19.454 0a4.513 4.513 0 0 0-3.214 1.332l-2.262 2.262 6.428 6.428 2.262-2.262c.859-.859 1.332-2 1.332-3.214a4.512 4.512 0 0 0-1.332-3.214z"
  }));
};

PencilIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
PencilIcon.defaultProps.solid = true;
export default PencilIcon;